import ResqlyMark from './ResqlyMark';

export default function ResqlyEmptyState({
  title,
  description,
  action,
  showMark = false,
  className = '',
}) {
  return (
    <div className={`flex flex-col items-center text-center py-10 px-4 ${className}`}>
      {showMark && <ResqlyMark size={48} className="mb-4 opacity-90" />}
      <h3 className="text-base font-semibold text-slate-900">{title}</h3>
      {description && (
        <p className="text-sm text-slate-500 mt-2 max-w-xs">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
